import { LocalFind, LocalInsert } from '@weblite/persist'
import { GetActiveSessions } from '@weblite/ts-action/auth'
import { json } from 'stream/consumers'

export const connectionReport = (() => {
  let startTime: number = null
  let updating = 0

  const setUpdating = () => {
    if (!updating) startTime = performance.now()
    // eslint-disable-next-line no-plusplus
    updating++
  }

  const getReportAndClear = () => {
    const duration = performance.now() - startTime
    const result = { duration, updating }

    startTime = null
    updating = 0

    return result
  }

  return { setUpdating, getReportAndClear }
})()

export const activeSessionsCache = {
  value: undefined as GetActiveSessions['Res'] | undefined,
  date: undefined as number | undefined,
  get(cacheTTLSeconds: number) {
    const date = activeSessionsCache.date
    const value = activeSessionsCache.value
    if (date && value && Date.now() - date < cacheTTLSeconds * 1000) {
      return value
    }
    return undefined
  },
  /**
   * Last value we ever received, ignoring the TTL. Used when the server
   * throttles us: an outdated count is a far better basis for enforcing the
   * device limit than no count at all.
   */
  getStale() {
    return activeSessionsCache.value
  },
  set(value: GetActiveSessions['Res']) {
    const date = Date.now()
    activeSessionsCache.value = value
    activeSessionsCache.date = date
  },
  /**
   * Must be called whenever sessions are terminated. The channel device-limit
   * gate reads this cache with a long TTL, so without invalidation a user who
   * just freed up a device would stay locked out until the TTL expired.
   */
  clear() {
    activeSessionsCache.value = undefined
    activeSessionsCache.date = undefined
  },
}
